module.exports = __webpack_public_path__ + "Roboto-Bold.d329cc8b34667f114a95.ttf";


//////////////////
// WEBPACK FOOTER
// D:/Ai3/Stago/SAST/Sources/SAST/src/Stago.AAI/ClientAppAngular/src/_stylesheets/fonts/Roboto/Roboto-Bold.ttf
// module id = ../../../../../src/_stylesheets/fonts/Roboto/Roboto-Bold.ttf
// module chunks = styles